export default "__VITE_ASSET__12p8Z6aW__"